import {
  faSortAlphaDown,
  faSortAlphaDownAlt,
  faSortAmountDown,
  faSortAmountDownAlt,
} from '@fortawesome/free-solid-svg-icons';

export const notesSortOptions = [
  {
    key: 'date-asc',
    field: 'timestamp',
    direction: 'asc',
    i18nKey: 'components.NotesSortMenu.dateAsc',
    icon: faSortAmountDown,
  },
  {
    key: 'date-desc',
    field: 'timestamp',
    direction: 'desc',
    i18nKey: 'components.NotesSortMenu.dateDesc',
    icon: faSortAmountDownAlt,
  },
  {
    key: 'name-asc',
    field: 'name',
    direction: 'asc',
    i18nKey: 'components.NotesSortMenu.nameAsc',
    icon: faSortAlphaDown,
  },
  {
    key: 'name-desc',
    field: 'name',
    direction: 'desc',
    i18nKey: 'components.NotesSortMenu.nameDesc',
    icon: faSortAlphaDownAlt,
  },
];
